"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const utils_1 = require("@loadsure/utils");
class PremiumOnlyTax {
    constructor(name, value, active) {
        this.name = name;
        this.value = value;
        this.active = active;
        this.type = __1.eTaxType.PREMIUM_ONLY;
        this.currency = "";
    }
    static fromObj(data) {
        return new PremiumOnlyTax(__1.getTaxComponentName(data), data.value, data.active !== false);
    }
    calculate(currency, premium) {
        return utils_1.roundToDecimals(premium * (this.value / 100));
    }
    get description() {
        return `${this.value}% of Premium`;
    }
}
exports.default = PremiumOnlyTax;
//# sourceMappingURL=premiumOnlyTax.class.js.map